export const getTableDataForSelectedElements = (table, selectedItems) => {
  return {
    ...table,
    lineElements: selectedItems,
    deleteCollection: selectedItems.length === table.rowsData.length,
  }
};

export default getTableDataForSelectedElements;
